var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.978 57.5586L98.8687 10.571C90.1075 12.9631 69.0544 18.9831 58.0501 22.142C54.1988 23.2464 51.9842 27.2465 53.1687 31.0805C57.392 44.7573 65.1631 68.6374 68.9514 80.214C70.1703 83.9451 74.1303 86.0052 77.89 84.9008L119.796 72.5744C123.579 71.4643 125.787 67.5386 124.74 63.7389C124.071 61.3183 123.384 58.8748 122.972 57.5643L122.978 57.5586Z",
    fill: "#94D133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0299 21.833L56.4248 23.75L73.1059 77.2841L121.112 62.2396C121.919 61.9878 122.588 61.427 122.983 60.6774C123.378 59.9334 123.458 59.0579 123.206 58.251V58.1766C121.043 51.2352 112.86 26.7601 108.877 14.8801C107.647 11.2005 103.756 9.14615 100.025 10.2048C88.8485 13.3923 66.8512 19.687 60.0357 21.8215L60.0299 21.833Z",
    fill: "#94D133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.97 62.9607C117.575 61.7018 117.421 60.3799 117.513 59.0637L116.431 59.4071L75.8297 72.0653C74.8855 72.4029 74.1015 73.0896 73.6495 73.988C73.1974 74.8865 73.1115 75.9222 73.4091 76.8836C73.7067 77.845 74.3648 78.6519 75.2403 79.1383C76.1216 79.6247 77.1516 79.7563 78.1244 79.4988L79.2404 79.1498L119.864 66.4801C119.018 65.4329 118.377 64.2426 117.97 62.9607Z",
    fill: "#E1F6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.284 79.4187C117.524 80.1969 116.854 80.958 116.047 80.815L108.923 79.5274L103.521 84.3915C102.931 84.9237 101.982 84.6662 101.753 83.9051L97.4036 69.7819L112.797 64.9121L117.284 79.4187Z",
    fill: "#9081FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.884 39.0406C66.5765 33.2551 73.4549 32.6199 75.103 37.4554C76.4821 41.5013 71.0515 49.0493 69.6209 51.7904L79.95 48.6659",
    stroke: "#42A50E",
    strokeWidth: 5.2876,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4597 29.4725C97.1521 23.687 104.031 23.0518 105.679 27.8873C107.058 31.9331 101.633 39.4811 100.197 42.2222L110.526 39.0977",
    stroke: "#42A50E",
    strokeWidth: 5.2876,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7942 39.3382L92.2592 36.351M86.0617 33.2551L89.066 42.7201",
    stroke: "#42A50E",
    strokeWidth: 5.2876,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCount);
export default __webpack_public_path__ + "static/media/card_count.0324bd0ab913aae85095a81d640e1a68.svg";
export { ForwardRef as ReactComponent };